const actionTypes = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",

  LOGIN_OAUTH_REQUEST: "LOGIN_OAUTH_REQUEST",
  LOGIN_OAUTH_SUCCESS: "LOGIN_OAUTH_SUCCESS",
  LOGIN_OAUTH_FAILURE: "LOGIN_OAUTH_FAILURE",

  SIGN_OUT: "SIGN_OUT",

  // REGISTER
  CREATE_USER_REQUEST: "CREATE_USER_REQUEST",
  CREATE_USER_SUCCESS: "CREATE_USER_SUCCESS",
  CREATE_USER_FAILURE: "CREATE_USER_FAILURE",
  // REGISTER OAUTH
  CREATE_USER_OAUTH_REQUEST: "CREATE_USER_OAUTH_REQUEST",
  CREATE_USER_OAUTH_SUCCESS: "CREATE_USER_OAUTH_SUCCESS",
  CREATE_USER_OAUTH_FAILURE: "CREATE_USER_OAUTH_FAILURE",

  // VERIFY
  VERIFY_GUID_REQUEST: "VERIFY_GUID_REQUEST",
  VERIFY_GUID_SUCCESS: "VERIFY_GUID_SUCCESS",
  VERIFY_GUID_FAILURE: "VERIFY_GUID_FAILURE",

  VERIFY_EMAIL_AND_PASS_REQUEST: "VERIFY_EMAIL_AND_PASS_REQUEST",
  VERIFY_EMAIL_AND_PASS_SUCCESS: "VERIFY_EMAIL_AND_PASS_SUCCESS",
  VERIFY_EMAIL_AND_PASS_FAILURE: "VERIFY_EMAIL_AND_PASS_FAILURE",

  UPDATE_USER_REQUEST: "UPDATE_USER_REQUEST",
  UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
  UPDATE_USER_FAILURE: "UPDATE_USER_FAILURE",

  CREATE_ORGAN_REQUEST: "CREATE_ORGAN_REQUEST",
  CREATE_ORGAN_SUCCESS: "CREATE_ORGAN_SUCCESS",
  CREATE_ORGAN_FAILURE: "CREATE_ORGAN_FAILURE",

  REFRESH_USER_REQUEST: "REFRESH_USER_REQUEST",
  REFRESH_USER_SUCCESS: "REFRESH_USER_SUCCESS",
  REFRESH_USER_FAILURE: "REFRESH_USER_FAILURE",

  CHANGE_PASSWORD_REQUEST: "CHANGE_PASSWORD_REQUEST",
  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_FAILURE: "CHANGE_PASSWORD_FAILURE",

  FORGOT_PASSWORD_REQUEST: "FORGOT_PASSWORD_REQUEST",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILURE: "FORGOT_PASSWORD_FAILURE",

  // GET MANUAL
  GET_MANUAL_REQUEST: "GET_MANUAL_REQUEST",
  GET_MANUAL_SUCCESS: "GET_MANUAL_SUCESS",
  GET_MANUAL_FAILURE: "GET_MANUAL_FAILURE",

  // MESSAGE
  FAILURE: "FAILURE",
  SHOW_MSG: "SHOW_MSG",
  HIDE_MSG: "HIDE_MSG",

  // APP HEADER
  SHOW_APP_HEADER: "SHOW_APP_HEADER",
  CHANGE_HEADER_TITLE: "CHANGE_HEADER_TITLE",

  GET_LIST_ZMLUVA_HEADER_REQUEST: "GET_LIST_ZMLUVA_HEADER_REQUEST",
  GET_LIST_ZMLUVA_HEADER_SUCCESS: "GET_LIST_ZMLUVA_HEADER_SUCCESS",
  GET_LIST_ZMLUVA_HEADER_FAILURE: "GET_LIST_ZMLUVA_HEADER_FAILURE",

  GET_LIST_ODBERATEL_HEADER_REQUEST: "GET_LIST_ODBERATEL_HEADER_REQUEST",
  GET_LIST_ODBERATEL_HEADER_SUCCESS: "GET_LIST_ODBERATEL_HEADER_SUCCESS",
  GET_LIST_ODBERATEL_HEADER_FAILURE: "GET_LIST_ODBERATEL_HEADER_FAILURE",

  GET_LIST_OM_HEADER_REQUEST: "GET_LIST_OM_HEADER_REQUEST",
  GET_LIST_OM_HEADER_SUCCESS: "GET_LIST_OM_HEADER_SUCCESS",
  GET_LIST_OM_HEADER_FAILURE: "GET_LIST_OM_HEADER_FAILURE",

  // Zmluvy
  CHANGE_ZMLUVA: "CHANGE_ZMLUVA",
  UPDATE_CUSTOM_FILTERS_ZMLUVY: "UPDATE_CUSTOM_FILTERS_ZMLUVY",

  GET_ZMLUVA_REQUEST: "GET_ZMLUVA_REQUEST",
  GET_ZMLUVA_SUCCESS: "GET_ZMLUVA_SUCCESS",
  GET_ZMLUVA_FAILURE: "GET_ZMLUVA_FAILURE",

  GET_LIST_ZMLUVA_REQUEST: "GET_LIST_ZMLUVA_REQUEST",
  GET_LIST_ZMLUVA_SUCCESS: "GET_LIST_ZMLUVA_SUCCESS",
  GET_LIST_ZMLUVA_FAILURE: "GET_LIST_ZMLUVA_FAILURE",

  // Odberne miesta
  CHANGE_OM: "CHANGE_OM",
  UPDATE_CUSTOM_FILTERS_OM: "UPDATE_CUSTOM_FILTERS_OM",

  GET_OM_REQUEST: "GET_OM_REQUEST",
  GET_OM_SUCCESS: "GET_OM_SUCCESS",
  GET_OM_FAILURE: "GET_OM_FAILURE",

  GET_LIST_OM_REQUEST: "GET_LIST_OM_REQUEST",
  GET_LIST_OM_SUCCESS: "GET_LIST_OM_SUCCESS",
  GET_LIST_OM_FAILURE: "GET_LIST_OM_FAILURE",

  // Faktury
  CHANGE_FAKTURA: "CHANGE_FAKTURA",
  UPDATE_CUSTOM_FILTERS_FAKTURY: "UPDATE_CUSTOM_FILTERS_FAKTURY",

  GET_FAKTURA_REQUEST: "GET_FAKTURA_REQUEST",
  GET_FAKTURA_SUCCESS: "GET_FAKTURA_SUCCESS",
  GET_FAKTURA_FAILURE: "GET_FAKTURA_FAILURE",

  GET_FAKTURA_PDF_REQUEST: "GET_FAKTURA_PDF_REQUEST",
  GET_FAKTURA_PDF_SUCCESS: "GET_FAKTURA_PDF_SUCCESS",
  GET_FAKTURA_PDF_FAILURE: "GET_FAKTURA_PDF_FAILURE",

  GET_LIST_FAKTURA_REQUEST: "GET_LIST_FAKTURA_REQUEST",
  GET_LIST_FAKTURA_SUCCESS: "GET_LIST_FAKTURA_SUCCESS",
  GET_LIST_FAKTURA_FAILURE: "GET_LIST_FAKTURA_FAILURE",

  // Spotreby
  UPDATE_SPOTREBA: "UPDATE_SPOTREBA",

  GET_SPOTREBA_REQUEST: "GET_SPOTREBA_REQUEST",
  GET_SPOTREBA_SUCCESS: "GET_SPOTREBA_SUCCESS",
  GET_SPOTREBA_FAILURE: "GET_SPOTREBA_FAILURE",

  // Dodavatel
  CHANGE_DODAVATEL: "CHANGE_DODAVATEL",
  UPDATE_DODAVATEL: "UPDATE_DODAVATEL",

  GET_DODAVATEL_REQUEST: "GET_DODAVATEL_REQUEST",
  GET_DODAVATEL_SUCCESS: "GET_DODAVATEL_SUCCESS",
  GET_DODAVATEL_FAILURE: "GET_DODAVATEL_FAILURE",

  GET_DODAVATEL_CURRENT_USER_REQUEST: "GET_DODAVATEL_CURRENT_USER_REQUEST",
  GET_DODAVATEL_CURRENT_USER_SUCCESS: "GET_DODAVATEL_CURRENT_USER_SUCCESS",
  GET_DODAVATEL_CURRENT_USER_FAILURE: "GET_DODAVATEL_CURRENT_USER_FAILURE",

  GET_LIST_DODAVATEL_REQUEST: "GET_LIST_DODAVATEL_REQUEST",
  GET_LIST_DODAVATEL_SUCCESS: "GET_LIST_DODAVATEL_SUCCESS",
  GET_LIST_DODAVATEL_FAILURE: "GET_LIST_DODAVATEL_FAILURE",

  // Odberatel
  CHANGE_ODBERATEL: "CHANGE_ODBERATEL",

  GET_ODBERATEL_REQUEST: "GET_ODBERATEL_REQUEST",
  GET_ODBERATEL_SUCCESS: "GET_ODBERATEL_SUCCESS",
  GET_ODBERATEL_FAILURE: "GET_ODBERATEL_FAILURE",

  GET_LIST_ODBERATEL_REQUEST: "GET_LIST_ODBERATEL_REQUEST",
  GET_LIST_ODBERATEL_SUCCESS: "GET_LIST_ODBERATEL_SUCCESS",
  GET_LIST_ODBERATEL_FAILURE: "GET_LIST_ODBERATEL_FAILURE",

  UPDATE_ODBERATEL_REQUEST: "UPDATE_ODBERATEL_REQUEST",
  UPDATE_ODBERATEL_SUCCESS: "UPDATE_ODBERATEL_SUCCESS",
  UPDATE_ODBERATEL_FAILURE: "UPDATE_ODBERATEL_FAILURE",

  UPDATE_CUSTOM_FILTERS_ODBERATEL: "UPDATE_CUSTOM_FILTERS_ODBERATEL",

  // Spravy
  CHANGE_SPRAVA: "CHANGE_SPRAVA",
  UPDATE_CUSTOM_FILTERS_SPRAVA: "UPDATE_CUSTOM_FILTERS_SPRAVA",

  GET_SPRAVA_REQUEST: "GET_SPRAVA_REQUEST",
  GET_SPRAVA_SUCCESS: "GET_SPRAVA_SUCCESS",
  GET_SPRAVA_FAILURE: "GET_SPRAVA_FAILURE",

  GET_LIST_SPRAVA_REQUEST: "GET_LIST_SPRAVA_REQUEST",
  GET_LIST_SPRAVA_SUCCESS: "GET_LIST_SPRAVA_SUCCESS",
  GET_LIST_SPRAVA_FAILURE: "GET_LIST_SPRAVA_FAILURE",

  GET_COUNT_NEPRECITANE_SPRAVY_REQUEST: "GET_COUNT_NEPRECITANE_SPRAVY_REQUEST",
  GET_COUNT_NEPRECITANE_SPRAVY_SUCCESS: "GET_COUNT_NEPRECITANE_SPRAVY_SUCCESS",
  GET_COUNT_NEPRECITANE_SPRAVY_FAILURE: "GET_COUNT_NEPRECITANE_SPRAVY_FAILURE",

  PUT_SPRAVA_REQUEST: "PUT_SPRAVA_REQUEST",
  PUT_SPRAVA_SUCCESS: "PUT_SPRAVA_SUCCESS",
  PUT_SPRAVA_FAILURE: "PUT_SPRAVA_FAILURE",

  // Fakt obsah
  CHANGE_FAKT_OBSAH: "CHANGE_FAKT_OBSAH",

  GET_FAKT_OBSAH_REQUEST: "GET_FAKT_OBSAH_REQUEST",
  GET_FAKT_OBSAH_SUCCESS: "GET_FAKT_OBSAH_SUCCESS",
  GET_FAKT_OBSAH_FAILURE: "GET_FAKT_OBSAH_FAILURE",

  GET_LIST_FAKT_OBSAH_REQUEST: "GET_LIST_FAKT_OBSAH_REQUEST",
  GET_LIST_FAKT_OBSAH_SUCCESS: "GET_LIST_FAKT_OBSAH_SUCCESS",
  GET_LIST_FAKT_OBSAH_FAILURE: "GET_LIST_FAKT_OBSAH_FAILURE",

  // TABLES
  GET_AA_DEF_OB_HODN_REQUEST: "GET_AA_DEF_OB_HODN_REQUEST",
  GET_AA_DEF_OB_HODN_SUCCESS: "GET_AA_DEF_OB_HODN_SUCCESS",
  GET_AA_DEF_OB_HODN_FAILURE: "GET_AA_DEF_OB_HODN_FAILURE",
};

export default actionTypes;
